import { Button } from "antd";
import styled from "styled-components";

export const StyledCropperContainer = styled.div`
    width: 100%;
    height: 100vh;
    overflow: hidden;

    cropper-canvas {
        width: 100%;
        height: 100%;
    }
`;

export const StyledIconButton = styled(Button)`
    color: ${({ theme }) => theme.colors.white};

    &:active,
    &:hover {
        color: ${({ theme }) => theme.colors.white} !important;
    }
`;
